export interface ArcDefinition {
  radius: number
  cx?: number
  cy?: number
  tooltip?: string
  link?: string,
  start_angle: number
  end_angle: number
  thickness: number
  opacity: number
  fill?: string
  d?: string
}

function polarToCartesian (centerX: number, centerY: number,
                           radius: number, angleInDegrees: number) {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0
  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  }
}

export function drawArc (opts: ArcDefinition) {
  const radius = opts.radius || 50
  const cx = opts.cx || radius
  const cy = opts.cy || radius
  const start = polarToCartesian(cx, cy, radius, opts.end_angle)
  const end = polarToCartesian(cx, cy, radius, opts.start_angle)
  const largeArcFlag = opts.end_angle - opts.start_angle <= 180 ? '0' : '1'

  const cutoutRadius = radius - opts.thickness
  const start2 = polarToCartesian(cx, cy, cutoutRadius, opts.end_angle)
  const end2 = polarToCartesian(cx, cy, cutoutRadius, opts.start_angle)

  const d = [
    'M', start.x, start.y,
    'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y,
    'L', cx, cy,
    'Z',

    'M', start2.x, start2.y,
    'A', cutoutRadius, cutoutRadius, 0, largeArcFlag, 0, end2.x, end2.y,
    'L', cx, cy,
    'Z'
  ].join(' ')
  opts.d = d
  return opts
}
